import React from 'react'
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Stack from '@mui/material/Stack';
import { ButtonOutlined } from '../mui-custom/MuiCustom';
import { RouteImage } from '../../assets/routeImage';
import { Typography } from '@mui/material';

type menuProps = {
    id: number;
    name: string;
    onClick?: () => void;
}
type Props = {
    menuItems: menuProps[];
    onClick?: () => void;
    buttonName: string;
    heading?: string;
    headingNormal?: boolean;
    headingAlign?: string;
}

const MenuDropdown: React.FC<Props> = (props: Props) => {
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef<HTMLButtonElement>(null);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event: Event | React.SyntheticEvent) => {
        if (
            anchorRef.current &&
            anchorRef.current.contains(event.target as HTMLElement)
        ) {
            return;
        }

        setOpen(false);
    };

    function handleListKeyDown(event: React.KeyboardEvent) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === 'Escape') {
            setOpen(false);
        }
    }
    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current!.focus();
        }

        prevOpen.current = open;
    }, [open]);
    return (
        <>
            {props.heading && (
                <div
                    className="mt-1"
                    style={{ textAlign: "left" || props.headingAlign }}
                >
                    <Typography variant={props.headingNormal ? 'subtitle1' : 'body1'}>
                        {props.heading}
                    </Typography>
                </div>
            )}
            <Stack direction="row" spacing={2}>
                <div className='w-full'>
                    <ButtonOutlined
                        sx={{
                            textTransform: "none",
                            width: "100%",
                            // minWidth: "auto",
                            maxWidth: "160px",
                            height: "43.5px",
                            backgroundColor: "inherit",
                            color: "#000",
                            border: `1px solid #E5E5E7`,
                            '&:hover': {
                                backgroundColor: "inherit"
                            }
                        }}
                        endIcon={<img width={15} src={RouteImage.download} />}
                        ref={anchorRef}
                        id="composition-button"
                        aria-controls={open ? 'composition-menu' : undefined}
                        aria-expanded={open ? 'true' : undefined}
                        aria-haspopup="true"
                        onClick={handleToggle}
                    >
                        {props.buttonName}
                    </ButtonOutlined>
                    <Popper
                        sx={{ zIndex: 9999 }}
                        open={open}
                        anchorEl={anchorRef.current}
                        role={undefined}
                        placement="bottom-start"
                        transition
                        disablePortal
                    >
                        {({ TransitionProps, placement }) => (
                            <Grow
                                {...TransitionProps}
                                style={{
                                    transformOrigin:
                                        placement === 'bottom-start' ? 'left top' : 'left bottom',
                                }}
                            >
                                <Paper sx={{width:100,textAlign:'center'}}>
                                    <ClickAwayListener onClickAway={handleClose}>
                                        <MenuList
                                            autoFocusItem={open}
                                            id="composition-menu"
                                            aria-labelledby="composition-button"
                                            onKeyDown={handleListKeyDown}
                                        >
                                            {props.menuItems?.map((list) => (
                                                <MenuItem onClick={list.onClick} key={list.id}>
                                                    {list.name}
                                                </MenuItem>
                                            ))}

                                        </MenuList>
                                    </ClickAwayListener>
                                </Paper>
                            </Grow>
                        )}
                    </Popper>
                </div>
            </Stack>
        </>
    )
}

export default MenuDropdown